import { useListState } from "../../lib/listState";
import { useQuery } from "@tanstack/react-query";
import { FileClock, Search } from "lucide-react";
import { api } from "../../lib/api";
import { formatDateTime, labelFromCode, statusTone } from "../shared/format";
import { RouteError, RouteLoading } from "../shared/PageState";

export default function AuditLogPage() {
  const [search, setSearch] = useListState("audit.search", "");
  const [action, setAction] = useListState("audit.action", "ALL");
  const auditQuery = useQuery({
    queryKey: ["tech-admin-audit", search, action],
    queryFn: () => api.listAdminAuditEvents({ search, action })
  });

  if (auditQuery.isLoading) return <RouteLoading />;
  if (auditQuery.isError || !auditQuery.data) {
    return <RouteError title="Audit log unavailable" detail={auditQuery.error instanceof Error ? auditQuery.error.message : "The admin audit log could not be loaded."} onRetry={() => auditQuery.refetch()} />;
  }

  return (
    <div className="pa-page-stack">
      <div className="pa-title-row">
        <div><p className="pa-eyebrow">Audit Log</p><h1>Admin change history</h1><p>Changes made through the tech-admin API, newest first.</p></div>
        <span className="pa-refresh-chip">Updated {formatDateTime(auditQuery.data.generated_at)}</span>
      </div>
      <section className="pa-panel">
        <div className="pa-toolbar">
          <label className="pa-search-field"><Search size={16} /><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search entity, ID or admin" /></label>
          <select value={action} onChange={(event) => setAction(event.target.value)}><option value="ALL">All actions</option><option value="CREATED">Created</option><option value="UPDATED">Updated</option><option value="DELETED">Deleted</option></select>
        </div>
        <div className="pa-table-scroll">
          <table className="pa-table">
            <thead><tr><th>Time</th><th>Action</th><th>Entity</th><th>Entity ID</th><th>Admin</th><th>Source</th></tr></thead>
            <tbody>
              {auditQuery.data.events.length === 0 ? <tr><td className="pa-empty-cell" colSpan={6}><FileClock size={18} /> No admin changes match these filters.</td></tr> : auditQuery.data.events.map((event) => (
                <tr key={event.audit_id}>
                  <td>{formatDateTime(event.created_at)}</td>
                  <td><span className={`pa-badge ${statusTone(event.action === "CREATED" ? "ACTIVE" : event.action)}`}>{event.action}</span></td>
                  <td>{labelFromCode(event.entity_type)}</td>
                  <td><small>{event.entity_id || "Not applicable"}</small></td>
                  <td><strong>{event.actor_name}</strong><small>{event.actor_mobile_number || ""}</small></td>
                  <td>{labelFromCode(event.source)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
